<div class="table-component">
  <ngx-datatable
    tableClass="table-striped table-bordered table-hover"
    class="material"
    [rows]="rows"
    [columns]="columnsConfig"
    [columnMode]="'force'"
    [headerHeight]="50"
    [footerHeight]="50"
    [rowHeight]="48"
    [selectionType]="'checkbox'"
    [scrollbarV]="true"
    [virtualization]="true"
    [selectAllRowsOnPage]="false"
    [selected]="selected"
    (select)="onSelectRow($event)"
    (activate)="onActivate($event)">
    @for (column of columnsConfig; track column; let i = $index) {
      <ngx-datatable-column
        [headerTemplate]="headerTemplate"
        [width]="column.width"
        [minWidth]="column.minWidth"
        [maxWidth]="column.maxWidth"
        [sortable]="column.sortable"
        name="{{ column.name }}"
        prop="{{ column.prop }}">
        <ng-template #headerTemplate let-allRowsSelected="allRowsSelected" let-selectFn="selectFn" let-sort="sortFn">
          <div class="table-component__cell-header">
            @if (column['type'] === ColumnTypes.CHECKBOX) {
              <div class="table-component__cell-checkbox-wrap">
                <pdq-checkbox
                  class="table-component-checkbox"
                  [checked]="selected.length"
                  [variant]="selected.length === rows.length ? 'hyper' : 'indeterminate'"
                  (onChange)="selectAll()">
                </pdq-checkbox>
              </div>
            } @else {
              @if (column['type'] === ColumnTypes.ORDER_NUMBER && isSelectedRows) {
                <div class="header-div">
                  @if (column['sortable']) {
                    <button class="table-component__sort-button" (click)="sortTable(i)">
                      <img src="assets/icons/{{ getSortingIconName(i) }}" alt="" />
                    </button>
                  }
                  @if (!column['hideColumnName']) {
                    <span class="table-component__cell-header-upper-text">
                      {{ selectedRowsNumber + ' selected orders' }}
                    </span>
                  }
                  <pdq-button
                    matTooltipClass="pdq-mat-tooltip"
                    matTooltip="Back to assign"
                    variant="ghost"
                    icon="move_back_to"
                    (onClick)="onClickColumnButtonHeader(selectedIds, column['buttonEventName'])">
                  </pdq-button>
                </div>
              } @else {
                @if (column['type'] === ColumnTypes.DROPWOWN_MENU && isSelectedRows) {
                  <div class="table-component__cell-header-dropdown">
                    <button
                      mat-button
                      [matMenuTriggerFor]="menu"
                      (menuOpened)="menuOpened(true, i)"
                      (menuClosed)="menuClosed(true, i)"
                      [disabled]="
                        !(commonDropDownOptions[column.dropdownOptionsProp]?.length > 0) || isDisableHeaderButtons
                      "
                      [ngClass]="getHeaderDropdownClass(i, column)">
                      <span class="table-component__cell-header-dropdown-text">{{ column['name'] }}</span>
                      <span class="select-arrow"></span>
                    </button>
                    <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                    <mat-menu #menu="matMenu" advanced-filters__panel>
                      @for (option of commonDropDownOptions[column.dropdownOptionsProp]; track option; let i = $index) {
                        <button mat-menu-item (click)="onDropdownButtonClickHeader(option, column)">
                          {{ option?.mainText }}
                        </button>
                      }
                    </mat-menu>
                  </div>
                } @else {
                  @if (column['sortable']) {
                    <button class="table-component__sort-button" (click)="sortTable(i)">
                      <img src="assets/icons/{{ getSortingIconName(i) }}" alt="" />
                    </button>
                  }
                  @if (!column['hideColumnName']) {
                    <span class="table-component__cell-header-upper-text">
                      {{ column['name'] }}
                    </span>
                  }
                  <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                  @if (column['buttonIconSrc'] && column['buttonEventName'] && isSelectedRows) {
                    <button
                      class="table-component__cell-text-button"
                      mat-icon-button
                      (click)="onClickColumnButtonHeader(selectedIds, column['buttonEventName'])">
                      <img
                        src="{{ column['buttonIconSrc'] }}"
                        matTooltipClass="pdq-mat-tooltip"
                        matTooltip="Back to assign" />
                    </button>
                  }
                }
              }
            }
          </div>
        </ng-template>
        <ng-template
          ngx-datatable-cell-template
          let-value="value"
          let-row="row"
          checkboxable="false"
          let-isSelected="isSelected"
          let-onCheckboxChangeFn="onCheckboxChangeFn">
          <div
            class="table-component__cell-body"
            [ngClass]="{
              'popover-arrow': column['type'] === ColumnTypes.SKU,
            }">
            @if (column['type'] === ColumnTypes.CHECKBOX) {
              <div class="table-component__cell-checkbox-wrap">
                <pdq-checkbox
                  class="table-component-checkbox"
                  [checked]="checkIfCellIsSelected(row)"
                  (onChange)="onCheckboxChangeFn($event)">
                </pdq-checkbox>
              </div>
            }
            @if (column['type'] === ColumnTypes.DROPWOWN_MENU) {
              <div class="table-component__cell-dropdown">
                <div>
                  <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                  <button
                    mat-button
                    [matMenuTriggerFor]="menu"
                    [disabled]="!(getSingleColumnDropdownOptions(row, column)?.length > 1) || row.isLoadingRateData"
                    (menuOpened)="menuOpened(false, i, row.orderNumber)"
                    (menuClosed)="menuClosed(false, i, row.orderNumber)"
                    [ngClass]="getCellDropdownClass(i, column, row)">
                    <span class="table-component__cell-dropdown-text">{{ value ? value : 'Missing data' }}</span>
                    <span class="select-arrow"></span>
                    @if (toDisplayAssignedIcon(column, row)) {
                      <div class="system-assigned">
                        <pdq-icon size="small" icon="Attention"></pdq-icon>
                        <span
                          pdqPopover
                          forcePosition="bottom"
                          (click)="$event.stopPropagation()"
                          [popoverTemplate]="contentNotPreferredChoiceComponent"
                          >{{ row.switchedToSelectedRate ? 'Not recommended rate' : 'Not preferred choice' }}</span
                        >
                      </div>
                    }
                  </button>
                  <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                  <mat-menu #menu="matMenu" advanced-filters__panel>
                    <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                    @for (option of getSingleColumnDropdownOptions(row, column); track option; let i = $index) {
                      <button mat-menu-item (click)="onDropdownButtonClick(option, column, row)">
                        <span class="table-component-cell-dropdown-text">{{ option?.mainText }}</span>
                      </button>
                    }
                  </mat-menu>
                </div>
              </div>
            }
            @if (column['type'] === ColumnTypes.SKU) {
              <div
                class="table-component__cell-text"
                [ngClass]="{
                  'table-component__cell-popover-column-pressed': focusedRowId === row.id,
                }"
                pdqPopover
                [popoverTemplate]="skuPopoverComponent">
                <div class="sku-column">
                  @if (row.products?.length === 1) {
                    <div class="product">
                      <div class="content">{{ row.products[0] }}</div>
                    </div>
                  }
                  <div [ngClass]="{ tags: !row.products || row.products?.length > 1 }">
                    <div class="content">{{ row.skuCount | textSuffixNumberValue: 'SKU' : value }}</div>
                  </div>
                  <ng-template #skuPopoverComponent>
                    <pdq-popover-container>
                      <pdq-skus-popover [order]="row"> </pdq-skus-popover>
                    </pdq-popover-container>
                  </ng-template>
                </div>
              </div>
            }
            @if (column['type'] === ColumnTypes.ORDER_NUMBER) {
              <div class="table-component__cell-text" pdqPopover [popoverTemplate]="contentComponent">
                {{ getRowTextValue(row, column['prop']) }}
                @if (row.isMergedOrder) {
                  <pdq-tag style="margin-left: 4px" variant="quaternary" mode="rect">Merged</pdq-tag>
                }
                @if (isShowMainColumnErrorIcon(row)) {
                  <img class="order-error-messages" src="../../../../../../assets/icons/batch-error-icon.svg" />
                }
                @if (isShowMainColumnWarningIcon(row)) {
                  <img class="order-error-messages" src="../../../../../../assets/icons/batch-warning-icon.svg" />
                }
                @if (isShowMainColumnInfoIcon(row)) {
                  <img class="order-error-messages" src="../../../../../../assets/icons/batch-info-icon.svg" />
                }
              </div>
            }
            <ng-template #contentComponent>
              <pdq-popover-container>
                <smart-batch-messages
                  [orderRateData]="row"
                  [buttonText]="'Remove from batch'"
                  [buttonLogoSource]="column['buttonIconSrc']"
                  (onReturnButtonClick)="onClickColumnButton(row, column['buttonEventName'])"
                  (onRetryButtonClick)="onRetryButtonClick($event)"
                  (onChangeSaturdayDelivery)="onChangeSaturdayDeliveryClick($event, row)">
                </smart-batch-messages>
              </pdq-popover-container>
            </ng-template>
            <ng-template #contentNotPreferredChoiceComponent>
              <pdq-popover-container [loading]="false">
                @if (row.switchedToSelectedRate) {
                  <div class="not-preferred-choice-wrapper">
                    <div>Recommended rate:</div>
                    <div class="service-level">
                      <div>
                        {{ row.originalRecommendedRate }}
                      </div>
                    </div>
                  </div>
                } @else {
                  <div class="not-preferred-choice-wrapper">
                    <div>Your preferred choice:</div>
                    <div class="service-level">
                      @for (serviceLevel of row.recommendedServiceLevelNamesForDisplay; track serviceLevel) {
                        <div>
                          {{ serviceLevel }}
                        </div>
                      }
                    </div>
                    @if (
                      row.isRecommendedServiceLevelExist &&
                      row.deliveryTimePredictionStatus === DeliveryTimePredictionStatus.INTIME
                    ) {
                      <div class="non-recommended-reason">
                        Wasn't recommended due to its late expected delivery time
                      </div>
                    }
                  </div>
                }
              </pdq-popover-container>
            </ng-template>
            @if (column['type'] === ColumnTypes.TEXT) {
              <div class="table-component__cell-text">
                @if (!row[column['propTitle']]) {
                  <div class="text-primary">{{ getRowTextValue(row, column['prop']) }}</div>
                }
                @if (row[column['propTitle']]) {
                  <div>
                    <div class="text-primary">{{ getRowTextValue(row, column['propTitle']) }}</div>
                    <div class="text-secondary">{{ getRowTextValue(row, column['prop']) }}</div>
                  </div>
                }
              </div>
            }
            @if (column.type === ColumnTypes.DELIVERY_PROMISE) {
              <div class="table-component__cell-delivery-promise">
                @if (!row.isLoadingRateData) {
                  <div
                    class="rate-promise"
                    [ngClass]="{
                      'rate-promise_intime':
                        row['deliveryTimePredictionStatus'] === DeliveryTimePredictionStatus.INTIME,
                      'rate-promise_late': row['deliveryTimePredictionStatus'] === DeliveryTimePredictionStatus.LATE,
                      'rate-promise_unknown':
                        row['deliveryTimePredictionStatus'] === DeliveryTimePredictionStatus.UNKNOWN,
                      'rate-promise_might-be-late':
                        row['deliveryTimePredictionStatus'] === DeliveryTimePredictionStatus.MIGHT_BE_LATE,
                      'rate-promise_for-pickup':
                        row['deliveryTimePredictionStatus'] === DeliveryTimePredictionStatus.MIGHT_BE_LATE,
                    }">
                    <div class="rate-promise__inner">
                      {{ deliveryTimeDisplay(row) }}
                    </div>
                    <span class="rate-promise__inner-delivey-date-default">
                      {{ getDeliveryPromiseText(row) }}
                    </span>
                  </div>
                }
                <div
                  class="table-component__cell-actions"
                  [ngClass]="{ syncing: row.isLoadingRateData }"
                  matTooltip="Syncing"
                  matTooltipClass="pdq-mat-tooltip">
                  <button
                    class="table-component__cell-actions-button"
                    [disabled]="true"
                    matTooltip="Syncing"
                    matTooltipClass="pdq-mat-tooltip">
                    <div
                      class="icon-sync action-icon"
                      [ngClass]="{ disabled: row.isLoadingRateData, spinning: row.isLoadingRateData }"></div>
                  </button>
                </div>
              </div>
            }
          </div>
        </ng-template>
      </ngx-datatable-column>
    }
  </ngx-datatable>
</div>
